import { useState, useEffect } from "react";

/**
 * useResendTimer - handles resend wait logic
 * @param initial Initial wait seconds
 */
export function useResendTimer(initial: number) {
  const [resendWait, setResendWait] = useState(initial);
  useEffect(() => {
    if (resendWait <= 0) return;
    const waitTimer = setInterval(() => {
      setResendWait((prev) => {
        if (prev <= 1) {
          clearInterval(waitTimer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(waitTimer);
  }, [resendWait]);
  return { resendWait, setResendWait };
}
